import { pitchClass } from "./notes";

export interface Tuning { id: string; label: string; strings: number[]; } // MIDI notes, lowest string first

export const TUNINGS: readonly Tuning[] = [
  { id: "guitar", label: "Guitar (standard E A D G B E)", strings: [40, 45, 50, 55, 59, 64] },
  { id: "guitar-dropd", label: "Guitar (drop D)", strings: [38, 45, 50, 55, 59, 64] },
  { id: "bass", label: "Bass (E A D G)", strings: [28, 33, 38, 43] },
  { id: "ukulele", label: "Ukulele (G C E A, re-entrant)", strings: [67, 60, 64, 69] },
];

export interface FretCell { string: number; fret: number; midi: number; pc: number; }

/** Every playable position from the open string (fret 0) to `frets`. Strings are listed lowest first. */
export function fretboard(tuning: Tuning, frets: number): FretCell[][] {
  return tuning.strings.map((open, s) =>
    Array.from({ length: frets + 1 }, (_, fret) => ({ string: s, fret, midi: open + fret, pc: pitchClass(open + fret) })),
  );
}

/** Positions of a set of pitch classes on the board. */
export function positionsOf(tuning: Tuning, frets: number, pcs: ReadonlySet<number>): FretCell[] {
  return fretboard(tuning, frets).flat().filter((c) => pcs.has(c.pc));
}

export const FRET_MARKERS = new Set([3, 5, 7, 9, 12, 15, 17, 19, 21, 24]);
